import * as React from 'react';
import ArticleIcon from '@mui/icons-material/Article';
import SavingsIcon from '@mui/icons-material/Savings';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import PersonIcon from '@mui/icons-material/Person';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LanIcon from '@mui/icons-material/Lan';
import GroupsIcon from '@mui/icons-material/Groups';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SecurityIcon from '@mui/icons-material/Security';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import FlagIcon from '@mui/icons-material/Flag';
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import StorageIcon from '@mui/icons-material/Storage';

class CustomerHistoryHelper {
  static sanitize({
    customerHistory,
    fridHistory,
    creditCheckHistory,
    snapshotHistory,
    customerWebhookHistory,
    sponsorApiEventHistory,
    disbursementHistory,
    notificationHistory,
    customerAuditTrail,
    customerServiceLog,
  }) {
    let historyItems = [];

    try {
      if (customerAuditTrail) {
        customerAuditTrail
          // .filter(
          //   ({ tableName, columnName, from }) =>
          //     ['status', 'date_deleted'].includes(columnName) && ['financing_requests'].includes(tableName)
          // )
          .forEach(({ changeDate, id, userId, tableName, columnName, to, from, user, fallbackUser, notes }) => {
            // if important throw in seperate buckets?!

            if (columnName === 'current_step_sku') {
              console.log('a step rewind happened ', changeDate, from, to);
              historyItems.push({
                time: changeDate,
                text: `Step Rewind ${from} => ${to}`,
                entity: 'Financing',
                color: 'warning',
                user,
                fallbackUser,
                notes,
              });
            }

            if (tableName === 'financing_requests' && columnName === 'date_deleted') {
              if (to) {
                historyItems.push({
                  time: changeDate,
                  text: `Financing Deleted`,
                  entity: 'Financing',
                  color: 'warning',
                  user,
                  fallbackUser,
                  notes,
                });
              } else if (from) {
                historyItems.push({
                  time: changeDate,
                  text: `Financing Reinstated`,
                  entity: 'Financing',
                  color: 'warning',
                  user,
                  fallbackUser,
                  notes,
                });
              }
            }

            if (tableName === 'quoting_customers' && columnName === 'hold_category_sku') {
              historyItems.push({
                time: changeDate,
                text: to !== null ? `Customer Hold Placed [ ${to} ]` : 'Customer Hold Removed',
                entity: 'CustomerHold',
                color: to !== null ? 'warning' : 'success',
                icon: to !== null ? <LockPersonOutlinedIcon /> : <LockOpenIcon />,
                user,
                fallbackUser,
                notes,
              });
            }

            historyItems.push({
              time: changeDate,
              text: `${tableName}.${columnName} went from ${from} to ${to}`,
              entity: 'AuditTrail',
              color: 'success',
              user,
              fallbackUser,
              notes,
            });
          });
      }

      customerWebhookHistory.forEach((webhook) => {
        let time = new Date().toISOString();
        let text = 'webhook';
        try {
          let request = JSON.parse(webhook.request);
          time = request.date;
          text = request.type;
        } catch (e) {}
        historyItems.push({ time: time, text: text, entity: 'Webhook', color: webhook.failed ? 'error' : 'success' });
      });

      sponsorApiEventHistory.forEach((sponsorEvent) => {
        historyItems.push({
          time: sponsorEvent.dateCreated,
          text: sponsorEvent.action,
          entity: 'Ensemble',
          color: sponsorEvent.failed ? 'error' : 'success',
        });
      });

      // console.table(customerHistory);
      historyItems.push({
        time: customerHistory[0].dateCreated,
        text: `customer created`,
        entity: 'Customer',
        id: customerHistory[0].id,
      });

      disbursementHistory?.forEach((disbursement) => {
        if (disbursement.d1DisbursementDateContractor) {
          historyItems.push({
            time: disbursement.d1DisbursementDateContractor,
            text: `D1 Disbursement`,
            entity: 'Disbursement',
            id: disbursement.id,
          });
        }
        if (disbursement.d2DisbursementDateContractor) {
          historyItems.push({
            time: disbursement.d2DisbursementDateContractor,
            text: `D2 Disbursement`,
            entity: 'Disbursement',
            id: disbursement.id,
          });
        }
      });

      notificationHistory?.forEach(({ id, method, eventType, subject, dateCreated, recipientAddress }) => {
        if (eventType === 'customer_hold_status_change') {
          historyItems.push({
            time: dateCreated,
            text: (
              <span>
                {subject.includes('Hold Removed') ? 'Hold Removed Notification' : 'Hold Placed Notification'} <br />
                recipient: {recipientAddress}
              </span>
            ),
            entity: 'CustomerHold',
            id,
          });
        }

        historyItems.push({
          time: dateCreated,
          text: (
            <span>
              Notification {eventType} [{subject}] <br />
              via {method} to {recipientAddress}
            </span>
          ),
          entity: 'Notification',
          id,
        });
      });

      let frids = [];
      if (fridHistory && fridHistory.length > 0) {
        fridHistory.forEach((fr) => {
          historyItems.push({
            time: fr.dateCreated,
            text: `Financing Created`,
            entity: 'Financing',
            id: fr.id,
          });

          if (fr.invoices && fr.invoices.length > 0) {
            fr.invoices.forEach(({ id, totalMaterialsAmount, dateFinalized }) => {
              historyItems.push({
                time: dateFinalized,
                text: `Invoice Finalized ${totalMaterialsAmount}`,
                entity: 'Invoice',
                id,
              });
            });
          }

          if (fr.cancellationReason) {
            // change order
            // super CPF
            // docs cancelled

            historyItems.push({
              time: fr.dateUpdated,
              text: `Financing Cancelled [${fr.cancellationReason}]`,
              entity: 'Financing',
              color: 'error',
              id: fr.id,
            });
          }
          frids.push(fr.id);
          fr.steps.forEach((step) => {
            if (step.status === 'accepted') {
              historyItems.push({
                time: step.dateUpdated,
                text: `${step.name} accepted`,
                entity: 'Step',
                color: 'success',
                id: step.id,
              });
            }
            step.docs.forEach((doc) => {
              if (doc.currentRevision) {
                historyItems.push({
                  time: doc.currentRevision?.dateCreated,
                  text: `${doc.name} generated`,
                  entity: 'Document',
                  id: doc.id,
                });
                if (doc.currentRevision.signers) {
                  doc.currentRevision.signers.forEach(
                    ({
                      id,
                      envelopeId,
                      status,
                      dateCreated,
                      signerRole,
                      dateUpdated,
                      kbaFailed,
                      signingMethod,
                      dateDeleted,
                    }) => {
                      if (dateDeleted) {
                        historyItems.push({
                          time: doc.currentRevision?.dateDeleted,
                          text: `${signerRole} For ${doc.name} Deleted`,
                          entity: 'Signer',
                          id,
                        });
                      }
                      historyItems.push({
                        time: doc.currentRevision?.dateDeleted,
                        text: `${signerRole} For ${doc.name} ${
                          signingMethod === 'signed_by_email' ? 'Email' : 'InPerson'
                        } Created`,
                        entity: 'Signer',
                        id,
                      });
                      if (kbaFailed) {
                        historyItems.push({
                          time: doc.currentRevision?.dateUpdated,
                          text: `${signerRole} For ${doc.name} KBA Failed`,
                          entity: 'Signer',
                          id,
                        });
                      }
                      if (status !== 'pending') {
                        historyItems.push({
                          time: doc.currentRevision?.dateDeleted,
                          text: `${signerRole} For ${doc.name} ${status}`,
                          entity: 'Signer',
                          id,
                        });
                      }
                    }
                  );
                }
              }
              if (doc.status === 'accepted') {
                if (doc.decisions) {
                  doc.decisions.forEach(({ dateCreated, decision, userId, userName }) => {
                    historyItems.push({
                      time: dateCreated,
                      text: `${doc.name} ${decision}`,
                      entity: 'Document',
                      color: decision === 'accepted' ? 'success' : 'warning',
                      id: doc.id,
                      user: {
                        userId,
                        username: userName,
                      },
                    });
                  });
                } else {
                  historyItems.push({
                    time: doc?.currentRevision?.dateUpdated || doc.dateUpdated,
                    text: `${doc.name} accepted`,
                    entity: 'Document',
                    color: 'success',
                    id: doc.id,
                  });
                }
              }
              if (doc.smsMessageGroups) {
                doc.smsMessageGroups.forEach((smsGroup) => {
                  smsGroup.smsMessages.forEach((message) => {
                    if (message.messageBody !== 'Message Group Initialized') {
                      historyItems.push({
                        time: message?.dateCreated,
                        text: (message?.inboundMessageId || '').includes('admin-override')
                          ? `Admin Override [${message.messageBody}]`
                          : `${message.messageBody}`,
                        entity: 'SMS',
                        color: 'primary',
                        id: message.originationNumber,
                      });
                    }
                  });
                });
              }
            });
          });
        });
      }
      if (creditCheckHistory) {
        creditCheckHistory.forEach((credit) => {
          historyItems.push({
            time: credit.dateCreated,
            text: `applied`,
            entity: 'Credit',
            color: 'warning',
            id: credit.id,
          });
          if (credit.status === 'Cancelled') {
            historyItems.push({
              time: credit.dateUpdated,
              text: `cancelled`,
              entity: 'Credit',
              color: 'error',
              id: credit.id,
            });
          } else if (credit.status === 'Pass') {
            historyItems.push({
              time: credit.bureauResponseDate,
              text: `status ${credit.status}`,
              entity: 'Credit',
              color: 'success',
              id: credit.id,
            });
          } else {
            historyItems.push({
              time: credit.bureauResponseDate,
              text: `status ${credit.status}`,
              entity: 'Credit',
              color: 'warning',
              id: credit.id,
            });
          }
          if (Array.isArray(credit.uniqueStips) && credit.uniqueStips.length > 0) {
            credit.uniqueStips.forEach((stip) => {
              if (!stip) {
                return;
              }
              historyItems.push({
                time: credit.dateCreated,
                text: `isRequired=${stip?.isRequired}`,
                entity: 'Stip',
                color: 'warning',
                id: stip.reqId,
              });
              if (stip.status === 'Accepted') {
                historyItems.push({
                  time: credit.dateUpdated,
                  text: `${stip.status}`,
                  entity: 'Stip',
                  color: 'success',
                  id: stip.reqId,
                });
              } else if (stip.status === 'Rejected') {
                historyItems.push({
                  time: credit.dateUpdated,
                  text: `${stip.status}`,
                  entity: 'Stip',
                  color: 'error',
                  id: stip.reqId,
                });
              }
            });
          }
        });
      }
      if (frids) {
        frids.sort((a, b) => (a.dateCreated < b.dateCreated ? -1 : 1));

        snapshotHistory
          .sort((a, b) => {
            return a?.Proposal?.RevisionCreatedDateTime < b?.Proposal?.RevisionCreatedDateTime ? -1 : 1;
          })
          .forEach((sh, i) => {
            let fm = sh?.Proposal?.FinancingMethods["'0'"];

            historyItems.push({
              time: (sh?.Proposal?.RevisionCreatedDateTime || '').replace(' ', 'T'),
              text: `Financing Set  $${fm?.AmountFinanced}, ${fm?.AnnualPercentageRate}% ${fm?.Term}m ${fm?.ProductSKU}`,
              entity: 'Financing',
              color: 'primary',
              id: frids[i],
            });
          });
      }

      if (customerAuditTrail) {
        let frStatusChanges = customerAuditTrail
          .filter(({ tableName, columnName }) => {
            return tableName === 'financing_requests' && columnName === 'status';
          })
          .sort((a, b) => (a.changeDate < b.changeDate ? -1 : 1));

        frStatusChanges.forEach(({ from, to, changeDate, user, fallbackUser, rowId }, index) => {
          if (
            to === 'cancelled' &&
            !historyItems.some(({ id, text }) => {
              return text === 'Financing Cancelled' || `${id}` === `${rowId}`;
            })
          ) {
            historyItems.push({
              time: changeDate,
              text: 'Financing Cancelled',
              entity: 'Financing',
              color: 'warning',
              id: `${rowId}`,
              user,
              fallbackUser,
            });
          }
          if (from === 'cancelled' && to === 'started') {
            historyItems.push({
              time: changeDate,
              text: 'ReInstate Initiated',
              entity: 'Financing',
              color: 'warning',
              id: `${rowId}`,
              user,
              fallbackUser,
            });
          }
          if (to === 'cancelled' && frStatusChanges[index + 1]?.to === 'started') {
            historyItems = historyItems.filter(({ id, text }) => {
              return text !== 'Financing Cancelled [Change-Order]' || `${id}` !== `${rowId}`;
            });

            historyItems.push({
              time: changeDate,
              text: 'Change Order Initiated',
              entity: 'Financing',
              color: 'error',
              id: `${rowId}->${
                frStatusChanges.find((a, i) => a?.rowId !== rowId && a?.to === 'started' && i > index)?.rowId
              }`,
              user,
              fallbackUser,
            });
          }
        });
      }
      if (customerServiceLog) {
        console.log('customerServiceLog', customerServiceLog);
        customerServiceLog.forEach((serviceLog) => {
          historyItems.push({
            time: serviceLog?.dateCreated,
            text: `${serviceLog.service} - ${serviceLog?.status} - Requested ${serviceLog?.rawRequest} Responded ${serviceLog.rawResponse}`,
            entity: 'ServiceLog',
            color: serviceLog?.status === 'Success' ? 'success' : 'warning',
            id: serviceLog.id,
          });
        });
      }
      //
      return historyItems.sort((a, b) => (a?.time || '').localeCompare(b?.time || ''));
    } catch (e) {
      return [];
    }
  }

  static getIcon(entity) {
    return {
      Document: <ArticleIcon />,
      Credit: <SavingsIcon />,
      Step: <SkipNextIcon />,
      Financing: <FolderCopyIcon />,
      Customer: <PersonIcon />,
      SMS: <PhonelinkRingIcon />,
      Stip: <WarningAmberIcon />,
      Webhook: <LanIcon />,
      Ensemble: <GroupsIcon />,
      Invoice: <ListAltIcon />,
      Signer: <AssignmentIcon />,
      Disbursement: <AccountBalanceIcon />,
      Notification: <NotificationsActiveIcon />,
      AuditTrail: <SecurityIcon />,
      ChangeOrder: <EditTwoToneIcon />,
      CustomerHold: <FlagIcon />,
      ServiceLog: <StorageIcon />,
    }[entity];
  }
}

export default CustomerHistoryHelper;
